import { z } from 'zod';
import {
    WidgetType,
    ZodBaseWidgetConfiguration,
    ZodGenericWidgetConfigurationDetails,
} from '../types';
import { zMarshalToBoolean, zMarshalToStrictIntNullable } from '../../ReachApi/Marshallers';

export const ZodTimeDateWidgetConfigurationDetails = ZodGenericWidgetConfigurationDetails.extend({
    format: z.string(),
    timezone: z.string(),
    offset: z.union([z.string(), z.number()]).nullish().transform(zMarshalToStrictIntNullable),
    weekday: z.string().nullish(),
    relative_to_week: z.unknown().transform(zMarshalToBoolean),
    clock_type: z.string().nullish(),
});

export type TimeDateWidgetConfigurationDetails = z.infer<
    typeof ZodTimeDateWidgetConfigurationDetails
>;

export const ZodTimeDateWidgetConfiguration = ZodBaseWidgetConfiguration.extend({
    type: z.literal(WidgetType.TIME_DATE),
    config: ZodTimeDateWidgetConfigurationDetails,
});

export type TimeDateWidgetConfiguration = z.infer<typeof ZodTimeDateWidgetConfiguration>;

export const ZodTimeDateState = z.object({
    lastUpdated: z.number().nullish(),
    // - Local Timezone
    localTimezone: z.string(),
    localTimestamp: z.number(),
    // - Deprecated: Timezone to display
    configuredTimezone: z.string(),
    //  - Deprecated: Date format
    configuredFormat: z.string(),
    currentTime: z.string().nullish(),
});

export type TimeDateState = z.infer<typeof ZodTimeDateState>;

export type TimeDateTemplateData = {
    Widget: { Id: number };
    wobj: { config: { clock_type: string | null | undefined }; widget: { widgetsid: number } };
    timezones: string[];
    d: Date;
    format: string;
};
